import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    paddingInline: 30,
  },
  title: {
    paddingBlock: 20,
    color: "#177739",
    width: "100%",
  },
  grid: {
    flexGrow: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: {
    marginTop: theme.spacing(10),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  spacing: {
    paddingInline: 10,
  },
  containerGrid: {
    paddingBottom: "10px",
  },
  sticky: {
    position: "fixed",
    bottom: 10,
  },
  buttonSticky: {
    padding: "8px 0px",
  },
}));
